module.exports = __webpack_public_path__ + "media/images/img-ac73f0aee0f386db21e37c38b1e039a6.jpg";